import { render, staticRenderFns } from "./jlw.vue?vue&type=template&id=1c4bcaba&scoped=true&"
var script = {}
import style0 from "./jlw.vue?vue&type=style&index=0&id=1c4bcaba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4bcaba",
  null
  
)

export default component.exports